export default __webpack_public_path__ + "static/media/image-2.e562b047.svg";